/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Custom finger-zoom (pinch-to-zoom) and tap-to-zoom for mobile product gallery
document.addEventListener('DOMContentLoaded', function() {
  var isMobile = function() {
    return window.matchMedia("screen and (max-width: 1007px)").matches;
  };

  var triggerZoom = function() {
    var zoomBtn = document.querySelector('[data-action="open-product-zoom"]');
    if (zoomBtn) {
      zoomBtn.click();
    }
  };

  // 1. Tap-to-zoom (click) on the slide image on mobile devices
  document.body.addEventListener('click', function(event) {
    if (!isMobile()) return;

    var slideImage = event.target.closest('.Product__SlideItem--image');
    if (slideImage) {
      if (event.target.tagName.toLowerCase() === 'img') {
        triggerZoom();
      }
    }
  });

  // 2. Pinch-to-zoom detection (2 or more touches) on mobile
  var lastZoomTime = 0;
  var handleTouch = function(event) {
    if (!isMobile()) return;

    if (event.touches && event.touches.length >= 2) {
      var slideImage = event.target.closest('.Product__SlideItem--image');
      if (slideImage) {
        var now = Date.now();
        if (now - lastZoomTime > 1500) { // Throttle zoom triggering
          lastZoomTime = now;
          triggerZoom();
        }
      }
    }
  };

  document.body.addEventListener('touchstart', handleTouch, { passive: true });
  document.body.addEventListener('touchmove', handleTouch, { passive: true });

  // iOS-specific gesture start for multi-touch/pinch
  document.body.addEventListener('gesturestart', function(event) {
    if (!isMobile()) return;

    var slideImage = event.target.closest('.Product__SlideItem--image');
    if (slideImage) {
      event.preventDefault();
      triggerZoom();
    }
  });
});